import { makeStyles, MenuItem, Switch, Tooltip, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { useCustomerMode } from 'src/hooks/useCustomerMode';

type CustomerModeToggleProps = {
  context: 'navigation' | 'table';
};

const useStyles = makeStyles((theme) => ({
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  label: {
    fontWeight: 'bold',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    flex: 1,
  },
  infoIcon: {
    fontSize: '1rem',
    color: theme.palette.text.secondary,
  },
  status: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
}));

const CustomerModeToggle = ({ context }: CustomerModeToggleProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { customerModeActive, setCustomerModeActive } = useCustomerMode();

  const infoKey = context === 'navigation' ? 'customerMode.infoNavigation' : 'customerMode.infoTable';

  return (
    <MenuItem className={classes.menuItem} onClick={() => setCustomerModeActive(!customerModeActive)}>
      <Typography className={classes.label}>{t('customerMode.label')}</Typography>
      <Tooltip title={t(infoKey as any)} placement="bottom">
        <InfoOutlinedIcon className={classes.infoIcon} onClick={(e) => e.stopPropagation()} />
      </Tooltip>
      <Typography className={classes.status}>
        {customerModeActive ? t('customerMode.active') : t('customerMode.inactive')}
      </Typography>
      <Switch
        size="small"
        checked={customerModeActive}
        onChange={(_, checked) => setCustomerModeActive(checked)}
        color="primary"
      />
    </MenuItem>
  );
};

export default CustomerModeToggle;
